/**
 * Status and priority badges for the support queue. Wording and colour live in
 * ./labels so non-component modules can share them.
 */

import { cn } from '@/lib/utils';
import type { SupportTicketPriority, SupportTicketStatus } from '@repo/types';
import { SUPPORT_PRIORITY_PRESENTATION, SUPPORT_STATUS_PRESENTATION } from './labels';

const base =
  'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap';

/** Cast API values, so an unknown enum member degrades instead of throwing. */
const FALLBACK = { label: '', className: 'bg-muted text-muted-foreground border-border' };

function titleCase(value: string): string {
  const spaced = value.replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function SupportStatusBadge({
  status,
  className,
}: {
  status: SupportTicketStatus;
  className?: string;
}) {
  const preset = SUPPORT_STATUS_PRESENTATION[status] ?? { ...FALLBACK, label: titleCase(status) };
  return <span className={cn(base, preset.className, className)}>{preset.label}</span>;
}

export function SupportPriorityBadge({
  priority,
  className,
}: {
  priority: SupportTicketPriority;
  className?: string;
}) {
  const preset =
    SUPPORT_PRIORITY_PRESENTATION[priority] ?? { ...FALLBACK, label: titleCase(priority) };
  return <span className={cn(base, preset.className, className)}>{preset.label}</span>;
}
